export const decodeAccessToken = (token) => {
    if (!token)
        return '';
    try {
        // JWT format: header.payload.signature
        const payload = token.split('.')[1];
        if (!payload)
            return '';
        const decoded = JSON.parse(atob(payload.replaceAll('-', '+').replaceAll('_', '/')));
        // Try common userId fields
        return decoded.username || decoded.sub || decoded.id || '';
    }
    catch {
        return '';
    }
};
